import styled from 'styled-components';

const UserInfoLabelWrapper = styled.div`
  margin-right: 8px;
`;

export default UserInfoLabelWrapper;



// WEBPACK FOOTER //
// ./components/TopNav/UserProfile/UserInfo/UserInfoLabelWrapper.js